import { PublicationList } from './PublicationList';
import Icon from '@material-ui/core/Icon';
import Box from '@material-ui/core/Box';

const publicationsResource = {
  list: PublicationList,
  icon: () => <Icon><Box component="img" src='icons/publications.svg' /></Icon>,
};

export default publicationsResource;